import { render } from "./InsuranceCompaniesTable.vue?vue&type=template&id=caaceb62"
import script from "./InsuranceCompaniesTable.vue?vue&type=script&lang=js"
export * from "./InsuranceCompaniesTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__